<template>
  <div id="page-tobas-form">
    <vs-row>
      <vs-col>
        <card-page card-title="TOBAs">
          <additive-widget
            ref="formTobas"
            v-model="model"
            :form-options="formOptions"
            :schema="addressPhoneNumbersSchema"
            :maxCount="3"
            label="TOBAs"
          />
        </card-page>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import CardPage from '../../../components/Views/CardPage';
import AdditiveWidget from '../../../../components/form/fields/AdditiveWidget';
import {
  selectOptions,
  datepickerOptions,
  arrayOptions
} from '@/components/form/FormElementOption';
import FormModelMixin from '../../../../components/mixins/FormModelMixin';
import FormFieldValidationMixin from '../../../../components/mixins/FormFieldValidationMixin';
import moment from 'moment';

export default {
  components: {
    CardPage,
    AdditiveWidget
  },
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  mixins: [FormModelMixin, FormFieldValidationMixin],
  data() {
    return {
      additiveForms: ['formTobas'],
      model: {
        tobas: [],
        status: null,
      },
      addressPhoneNumbersSchema: {
        groups: [
          {
            styleClasses: 'w-full',
            fields: [
              {
                model: 'tobas',
                ...arrayOptions,
                showRemoveButton: true,
                items: {
                  type: 'object',
                  styleClasses: 'w-full',
                  schema: {
                    groups: [
                      {
                        styleClasses: 'w-full',
                        fields: [
                        {
                            type: 'vueMultiSelect',
                            styleClasses: 'w-1/3',
                            label: 'Status',
                            model: 'status',
                            values: () => this.statusOptions,
                            selectOptions: {
                              showLabels: false,
                              hideSelected: false,
                            },
                          },
                        ],
                      },
                      {
                        styleClasses: 'w-full mt-4',
                        fields: [
                          {
                            type: 'vueMultiSelect',
                            styleClasses: 'w-1/3',
                            label: 'Type',
                            model: 'TOBAType_FK',
                            values: () => this.tobaTypeOptions,
                            selectOptions,
                            required: true,
                            validator: 'required',
                          },
                          {
                            visible: (value) => value.status == 'OPEN' || value.status == 'CLOSED',
                            ...datepickerOptions,
                            styleClasses: 'w-1/3',
                            label: 'Start Date',
                            model: 'StartDate',
                            onChanged: () => this.validateField('ExpiryDate'),
                            required: true,
                            validator: [
                              'required',
                              'string',
                              (value, field, model) => {
                                if (model.ExpiryDate) {
                                  let startDate = model.StartDate;
                                  let expiryDate = moment(model.ExpiryDate).unix();

                                  if (typeof startDate === 'string') {
                                    startDate = moment(
                                      model.StartDate,
                                      'YYYY-MM-DD'
                                    ).unix();
                                  } else {
                                    startDate = startDate / 1000;
                                  }

                                  if (expiryDate < startDate) {
                                    return 'Expiry Date must be after Inception Date.';
                                  }
                                }

                                return true;
                              }
                            ]
                          },
                          {
                            visible: (value) => value.status == 'CLOSED',
                            ...datepickerOptions,
                            styleClasses: 'w-1/3',
                            label: 'Expiry Date',
                            model: 'ExpiryDate',
                            onChanged: () => this.validateField('StartDate'),
                            required: true,
                            validator: [
                              'required',
                              'string',
                              (value, field, model) => {
                                if (model.StartDate) {
                                  let startDate = model.StartDate;
                                  let expiryDate = moment(model.ExpiryDate).unix();

                                  if (typeof startDate === 'string') {
                                    startDate = moment(
                                      model.StartDate,
                                      'YYYY-MM-DD'
                                    ).unix();
                                  } else {
                                    startDate = startDate / 1000;
                                  }

                                  if (expiryDate < startDate) {
                                    return 'Expiry Date must be after Inception Date.';
                                  }
                                }

                                return true;
                              }
                            ]
                          },
                          {
                            type: 'textArea',
                            inputType: 'textArea',
                            styleClasses: 'w-full mt-4',
                            label: 'Note',
                            model: 'Note',
                            rows: 4
                          }
                        ]
                      }
                    ]
                  }
                }
              },
            ]
          }
        ]
      },
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: true
      },
      statusOptions:[
        'OPEN',
        'CLOSED',
        'NOT APPLICABLE',
      ],
      tobaTypeOptions: [],
      options: [
        {
          endpoint: () => this.$api.companyToba.getOptions(),
          optionsFieldName: 'tobaTypeOptions',
          nameFieldName: 'Type',
          idFieldName: 'TOBAType_FK'
        }
      ]
    };
  },
  computed: {
    showAddButton() {
      return this.value.tobas.length < 3 && this.componentAccess.canCreate.access;
    }
  },
};
</script>

<style scoped>
</style>
